var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrossRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85378 9.14653C9.90024 9.19298 9.93709 9.24813 9.96223 9.30883C9.98737 9.36953 10.0003 9.43458 10.0003 9.50028C10.0003 9.56598 9.98737 9.63103 9.96223 9.69173C9.93709 9.75242 9.90024 9.80757 9.85378 9.85403C9.80733 9.90048 9.75218 9.93733 9.69148 9.96247C9.63079 9.98762 9.56573 10.0006 9.50003 10.0006C9.43434 10.0006 9.36928 9.98762 9.30859 9.96247C9.24789 9.93733 9.19274 9.90048 9.14628 9.85403L5.00003 5.70715L0.853784 9.85403C0.759964 9.94785 0.632716 10.0006 0.500034 10.0006C0.367352 10.0006 0.240104 9.94785 0.146284 9.85403C0.0524635 9.76021 -0.000244138 9.63296 -0.000244141 9.50028C-0.000244143 9.3676 0.0524635 9.24035 0.146284 9.14653L4.29316 5.00028L0.146284 0.854028C0.0524635 0.760208 -0.000244141 0.63296 -0.000244141 0.500278C-0.000244141 0.367596 0.0524635 0.240348 0.146284 0.146528C0.240104 0.0527077 0.367352 0 0.500034 0C0.632716 0 0.759964 0.0527077 0.853784 0.146528L5.00003 4.2934L9.14628 0.146528C9.2401 0.0527077 9.36735 -2.61548e-09 9.50003 0C9.63272 2.61548e-09 9.75996 0.0527077 9.85378 0.146528C9.94761 0.240348 10.0003 0.367596 10.0003 0.500278C10.0003 0.63296 9.94761 0.760208 9.85378 0.854028L5.70691 5.00028L9.85378 9.14653Z",
    fill: "#F5CCC7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrossRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cross-Red.3ed05a08be8244bcc529073eab215c39.svg";